export const ERROR_401 = 'ERROR_401';
export const ERROR_403 = 'ERROR_403';
export const ERROR_404 = 'ERROR_404';
export const ERROR_422 = 'ERROR_422';
export const ERROR_500 = 'ERROR_500';

